import axios from "axios";

const API = axios.create({
  baseURL: "https://drishti-api.herokuapp.com",
  // baseURL: "http://localhost:9000",
});

export const getProject = (project) => API.get(`/${project}`);
